module.exports = __webpack_public_path__ + "static/media/badge-completed.61a51598.svg";